import { type Common } from './common.js';
import {
  type CommunicationVendor,
  type CommunicationVendorAccount,
} from './models/communicationVendorAccount.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';

export interface FindAllOptions {
  vendors?: CommunicationVendor[];
  organizationIds?: string[];
}

export class API {
  common: Common;
  readonly baseEndpoint = '/communication-vendor-accounts';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<CommunicationVendorAccount>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<CommunicationVendorAccount> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }
}
